import React from 'react';
import { Eye, Download } from './icons';
import { downloadEvidenceViaAPI } from '../utils/evidenceProxy';

export default function EvidenceItem({ url, name, mime, size, onView }) {
    const isImage = !mime || mime.startsWith('image/');

    // Si no hay mime, adivinar por extensión
    const looksLikeImage = isImage || (name && /\.(jpg|jpeg|png|gif|webp)$/i.test(name));

    return (
        <div className="flex items-center space-x-2 bg-white dark:bg-gray-800 p-2 rounded border border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
            <div className="flex-1 flex items-center space-x-2 min-w-0 cursor-pointer" onClick={onView}>
                <div className="flex-shrink-0">
                    {looksLikeImage ? <Eye className="w-4 h-4 text-blue-500" /> : <Download className="w-4 h-4 text-purple-500" />}
                </div>
                <div className="flex-1 min-w-0">
                    <p className="text-xs font-medium text-blue-600 dark:text-blue-400 truncate hover:underline" title={name}>{name}</p>
                    {size && <p className="text-[10px] text-gray-500">{(size / 1024 / 1024).toFixed(2)} MB</p>}
                </div>
            </div>
            <button onClick={() => downloadEvidenceViaAPI(url, name)} className="text-gray-400 hover:text-green-500">
                <Download className="w-4 h-4" />
            </button>
        </div>
    );
}
